<template>
    <div class="signIn">
        <div class="text1">申请报名吉林一号遥感开发者培训班</div>
        <div class="white" v-if="offlineStatus==1">
          <div class="text2">您已成功提交报名申请，请耐心等待审核~</div>
          <div class="buttonGroup">
            <div class="btnHome" @click="$router.push('/');refreshLocation();">返回首页</div>
            <div class="btnOther" @click="$router.push('/offlineSignIn');">报名其他站</div>
          </div>
        </div>
        <div class="white" v-if="offlineStatus==2">
            <div class="text2">您已成功通过报名审核，微信扫码下方二维码添加客服了解详细时间安排~</div>
            <img :src="weChatLink" alt="" class="erweima">
            <div class="buttonGroup">
              <div class="btnHome" @click="$router.push('/');">返回首页</div>
              <div class="btnOther" @click="$router.push('/offlineSignIn');">报名其他站</div>
            </div>
        </div>
        <div class="white" style="height: 400px;" v-if="offlineStatus==3">
            <div class="text2">很抱歉，您未通过报名审核，如有问题请联系教育专员。<br>
              0431-86008580（非节假日08:30~17:30）
            </div>
            <div class="buttonGroup" style="top: 300px;">
              <div class="btnHome" @click="$router.push('/');refreshLocation();">返回首页</div>
              <div class="btnOther" @click="$router.push('/offlineSignIn');">报名其他站</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
      name: "offlineResult",
      data() {
        return {
            offlineStatus:1,
            weChatLink:'',
        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
        refreshLocation() {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
          });
        },
        getCampList(){
          this.axios.get("/learn_back/course/register/getCampList", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
           this.weChatLink=res.data.data.weChatLink
          })
        },
        getOfflineStatus(){
          this.axios.get("/learn_back/course/register/getOfflineStatus?qs=13", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((res) => {
            this.offlineStatus=res.data.data
          })
        },
      },
    
      mounted() {
        this.refreshLocation()
        this.getCampList()
        this.getOfflineStatus()
      },
      created(){
      }
    };
</script>
<style scoped>
    .signIn {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f5f5f6;
}
.text1 {
  position: absolute;
  top: 174px;
  left: calc(50% - 208px);
  width: 416px;
  height: 31px;
  font-size: 26px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: normal;
  color: #3a3a3a;
  line-height: 31px;
  text-align: center;
}
.white {
  position: absolute;
  top: 259px;
  left: calc(50% - 640px);
  width: 1280px;
height: 600px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}
.text2{
    position: absolute;
    top: 119px;
    left: calc(50% - 640px);
    width:1280px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: center;

}
.homeBack{
    position: absolute;
    top: 500px;
    left: calc(50% - 75px);
    width: 150px;
height: 44px;
background: #C49760;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.text3{
    position: absolute;
    top: 67px;
    left: calc(50% - 100px);
    width: 200px;
height: 37px;
font-size: 26px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 37px;
text-align: center;
}
.text4{
    position: absolute;
    top: 136px;
    left: calc(50% - 400px);
    width: 800px;
height: 64px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 32px;
text-align: center;
}
.erweima{
  position: absolute;
  width: 200px;
  top: 190px;
  left: calc(50% - 100px);
}
.buttonGroup{
    position: absolute;
    top: 500px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 20px;
}
.btnHome{
    width: 150px;
    height: 44px;
    background: #C49760;
    border-radius: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.btnOther{
    width: 150px;
    height: 44px;
    background: #FFFFFF;
    border: 1px solid #C49760;
    border-radius: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #C49760;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
}
</style>